import { createSlice } from "@reduxjs/toolkit";
// Initial state of the dresses slice
const initialState = {
  selectedCategory: "all", // Default selected category is 'all'
};
// Create a dresses slice using createSlice function
const dressesSlice = createSlice({
  name: "dresses", // Name of the slice
  initialState, // Initial state
  reducers: {
    // Reducer function to handle filtering the category
    filterCategory: (state, action) => {
      state.selectedCategory = action.payload; // Update the selected category with the payload value
    },
  },
});
// Export the filterCategory action creator
export const { filterCategory } = dressesSlice.actions;
// Selector function to retrieve the selected category from the state
export const getSelectedCategory = (state) => state.dresses.selectedCategory;
// Export the reducer function generated by createSlice
export default dressesSlice.reducer;
